import { Navigate, Outlet } from 'react-router';
import { Loading } from '@/components/Loading/Loading';
import { useGetFeatureFlagsQuery } from '@/services/ApiService';

export type FeatureFlagOutletGateProps = {
    /** Env-backed key from GET /feature-flags. */
    flagKey: string;
    /** Where to send the user when the flag is off after flags have loaded. */
    redirectTo?: string;
};

/**
 * For nested routes behind a feature flag: waits for /feature-flags before choosing a branch.
 * Avoids a false "off" on direct URL or refresh while `data` is still empty (same render cycle
 * that used to redirect to the fallback route too early).
 */
export const FeatureFlagOutletGate = ({ flagKey, redirectTo = '/dashboard' }: FeatureFlagOutletGateProps) => {
    const { data, isLoading } = useGetFeatureFlagsQuery();
    const enabled = data?.[flagKey] === true;

    if (isLoading) {
        return <Loading />;
    }

    if (!enabled) {
        return <Navigate to={redirectTo} replace />;
    }

    return <Outlet />;
};
